export function on(c, reducer) {
    var types = typeof c === "function" ?
        [c.type] :
        Object.keys(c).reduce(function (t, k) { return t.concat([c[k].type]); }, []);
    return { reducer: reducer, types: types };
}
export function reducer(ons, initialState) {
    var map = new Map();
    ons.forEach(function (on) { return on.types.forEach(function (type) { return map.set(type, on.reducer); }); });
    return function (state, action) {
        if (state === void 0) { state = initialState; }
        var reducer = map.get(action.type);
        return reducer ? reducer(state, action) : state;
    };
}
